import React from 'react';
import { FormattedMessage } from 'react-intl';

import type { CurrentResult, JourneyResult } from './types';
import {
  TXTWCL_AlsoX_double_check_the_documen_ELL,
  TXTWCL_Error_reading_documentX,
  TXTWCL_Please_check_the_image_Xnot_bl_ELL,
  TXTWCL_Please_make_sure_you_can_see_a_ELL,
  TXTWCL_Something_isnXt_quite_rightX_b_ELL,
  TXTWCL_SorryX_there_was_a_technical_i_ELL,
  TXTWCL_TipX_Make_sure_the_image_is_in_ELL
} from './utils.messages.json';

const getErrorMessage = (currentResult?: CurrentResult) => {
  switch (currentResult) {
    case 'CaseUpdateFailed':
    case 'ErrorSavingData':
    case 'ProcessingError':
    case 'CommunicationError':
    case 'ScannerError':
    case 'SpecifiedEntryNotFound':
      return (
        <>
          <p>
            <FormattedMessage {...TXTWCL_Error_reading_documentX} />{' '}
            <FormattedMessage {...TXTWCL_SorryX_there_was_a_technical_i_ELL} />
          </p>
          <p>
            <FormattedMessage {...TXTWCL_Please_check_the_image_Xnot_bl_ELL} />{' '}
            <FormattedMessage {...TXTWCL_TipX_Make_sure_the_image_is_in_ELL} />
          </p>
        </>
      );
    case 'Failed':
      return (
        <>
          <FormattedMessage {...TXTWCL_Something_isnXt_quite_rightX_b_ELL} />{' '}
          <FormattedMessage {...TXTWCL_Please_make_sure_you_can_see_a_ELL} />{' '}
          <FormattedMessage {...TXTWCL_AlsoX_double_check_the_documen_ELL} />
        </>
      );
    default:
      return undefined;
  }
};

export const getError = (journeyResult?: JourneyResult) => {
  if (journeyResult) {
    const { highLevelResult, currentResult } = journeyResult;
    const hasHighLevelResultError =
      !!highLevelResult &&
      ['Expired', 'NotAccepted', 'Notsupported', 'Undefined'].includes(highLevelResult);

    return hasHighLevelResultError ? getErrorMessage(currentResult) : undefined;
  }
};

export const hasError = (journeyResult?: JourneyResult) => !!getError(journeyResult);

export const checkCameraPermission = async () => {
  try {
    await navigator.mediaDevices.getUserMedia({ video: true });
  } catch (err) {
    return !(
      (err instanceof Error && err.message === 'getUserMedia API Unavailable') ||
      err instanceof DOMException
    );
  }

  return true;
};
